import { CONSTANTS } from "client/utils/constants"
import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getBulkOrderManagedEquipmentDropDown, getCatalogItems, getMakeList, getManagedEquipementTypes, getVehicleSpecList, getVehicleType, removeBulkOrderAttachment, setOrderCartData, setOrderData, showMyCartAlert, uploadBulkOrderAttachments } from "Store/Component/BulkOrder/BulkOrderAction"
import OrderTypeSelection from "./OrderTypeSelection"
import { getFileName } from "utils";
import { v1 as uuid } from "uuid";
import ConfirmationBee from "../../../../../assets/images/ConfirmationBee.svg";
import DealerDetailsValidation from "../ManagedEquipements/DealerDetails/DealerDetailsValidation"

const OrderTypeSelectionContainer = (props:any) => {

    const { vehicle, isEditOrder, setdeletedItemFromCart, deletedItemFromCart } = props

    const dispatch = useDispatch()

    const {
        vehicleType,
        makeList,
        vehicleSpecList,
        orderDetails,
        selectedOrderType,
        managedEquipementsList,
        catalogItemDetails,
        orderCartDetails,
        attachmentList,
        BulkOrdeByIdValue,
        managedEquipmentDropDown
    }: any = useSelector(
        (state: any) => ({
            requisitionTypeList: state.AssetManagement.AssetType,
            selectedOrderType: state.BulkOrderReducer.selectedOrderType,
            vehicleType: state.BulkOrderReducer.vehicleType,
            makeList: state.BulkOrderReducer.makeList,
            vehicleSpecList: state.BulkOrderReducer.vehicleSpecList,
            orderDetails: state.BulkOrderReducer.orderDetails,
            orderCartDetails: state.BulkOrderReducer.orderCartDetails,
            managedEquipementsList: state.BulkOrderReducer.managedEquipementsList,
            catalogItemDetails: state.BulkOrderReducer.catalogItemDetails,
            attachmentList: state.BulkOrderReducer.attachmentList,
            BulkOrdeByIdValue: state.BulkOrdeByIdReducer.bulkOrderbyIdValue,
            managedEquipmentDropDown: state.BulkOrderReducer.managedEquipmentDropDown
        })
    )
   const [attachmentsList, setAttachmentsList] = useState<any>([]);
    const [list, setList] = useState<any>([])
    const [error, setError] = useState('')
    const [listVehicle, setListVehicle] = useState<any>([])
    const [errorVehicle, setErrorVehicle] = useState('')
    const [showVehicleDetails, setShowVehicleDetails] = useState(false)
    const [showManagedEquipDetails, setShowManagedEquipDetails] = useState(false)
    const [specDropDown, setSpecDropDown] = useState<any>([])
    const [makeDropDown, setMakeDropDown] = useState<any>([])
    const [catalogItems, setCatalogItems] = useState<any>([])
    const [searchcatalogItem, setSearchCatalogItem] = useState<any>(false)
    const [Popupcontent, setPopupcontent] = useState<any>({
        title: "",
        isDialogVisible: false,
        isTitleWarning: false,
        subtextcontent: "",
        primaryBtnText: "",
        outlineBtnText: "",
        popupPrimarybtnOnclick: () => { },
        popupOutlinebtnOnclick: () => { },
        isSingleConfirmationBtn: false,
        isCommentboxVisible: false,
        isCompletedReportVisible: false,
        titleImg: "",
        isCommentBoxRequire: false,
        outlineBtnnavigateTo: "",
        primaryBtnnavigateTo: "",
        actionby: "",
        value: 0,
        comments: "",
    });

    useEffect(()=>{
        setList([])
        setError('Error')
    },[])

    useEffect(() => {
        if(deletedItemFromCart){
        let catalogItemTemps = [...catalogItems]
        const tempOrderData = orderDetails ? JSON.parse(JSON.stringify(orderDetails)) : []
        catalogItemTemps?.forEach((element: any, _i: any) => {
            if (element.assetModelId === deletedItemFromCart) {
                element.isSelected = !element.isSelected;
                element.quantity = 1;
                setCatalogItems(catalogItemTemps);
                if(!element.isSelected){
                    tempOrderData?.forEach((val: any)=> {
                        if(val?.requestIndex == vehicle?.requestIndex){
                            val.selectedCatalogItems = val?.selectedCatalogItems?.filter((selectedItem: any) => selectedItem?.assetModelId !== deletedItemFromCart)
                            let NoNAPList:any = [];
                            NoNAPList = val?.selectedCatalogItems?.filter((selectedItem: any) => !selectedItem?.price)
                            if(!NoNAPList?.length){
                                val.attachmentError = "";
                            }
                        }
                    })
                    dispatch(setOrderData(tempOrderData))
                }
            }})
            setdeletedItemFromCart(null)
        }
    }, [deletedItemFromCart])

    useEffect(()=>{
        if(isEditOrder){
            setShowVehicleDetails(true)
            setShowManagedEquipDetails(true);
        }
    },[isEditOrder])

    useEffect(()=>{
            if(!vehicleType?.length && vehicle?.requestType === CONSTANTS?.VEHICLE_REQUEST){
                dispatch(getVehicleType(selectedOrderType?.orderRequestTypeId))
            }

            if(!managedEquipementsList?.length && vehicle?.requestType === CONSTANTS?.MANAGED_EQUIPMENT){
                dispatch(getManagedEquipementTypes(selectedOrderType?.orderRequestTypeId))
            } 
            setListVehicle([])
            setErrorVehicle('Error')
    },[vehicle?.requestType])

    useEffect(() => {
      if(BulkOrdeByIdValue){
        orderDetails?.map((orderitem: any, orderIndex: any) => {
                if(vehicle?.requestIndex == orderitem?.requestIndex){
                setList(orderitem?.attachments)
                setAttachmentsList(orderitem?.attachments)
                }
        })
      }
    },[BulkOrdeByIdValue])

    useEffect(()=>{
        if(vehicle?.selectedVehicleType?.value && showVehicleDetails){
            dispatch(getMakeList(vehicle?.selectedVehicleType?.value, vehicle?.requestIndex))
        }
    }, [vehicle?.selectedVehicleType?.value, showVehicleDetails])

    useEffect(()=>{
        if(vehicle?.selectedMake?.value && vehicle?.selectedVehicleType?.value){
            dispatch(getVehicleSpecList(vehicle?.selectedMake?.value, vehicle?.selectedVehicleType?.value, vehicle?.requestIndex))
        }
    }, [vehicle?.selectedMake?.value, vehicle?.selectedVehicleType?.value])

    useEffect(() => {
        if (catalogItemDetails != undefined && catalogItemDetails?.response?.length && searchcatalogItem) {
            setSearchCatalogItem(false)
            if (vehicle?.requestIndex === catalogItemDetails?.requestIndex) {
                let list = catalogItemDetails?.response?.length ? [...catalogItemDetails.response] : []
                list?.forEach((item => {
                    item.quantity = 1;
                }))
                setCatalogItems(list)
            }
        } else {
            if(searchcatalogItem && vehicle?.selectedEquipementType?.value){
            let decriptionTxt = (<>
                <p>No catalog item.</p>
            </>);
            setPopupcontent({
                ...Popupcontent,
                titleImg: ConfirmationBee,
                title: CONSTANTS.TITLE_CONFIRMATION,
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                outlineBtnText: "Ok",
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                },
                isSingleConfirmationBtn: true,
            });
        }
        }
    }, [catalogItemDetails])

    useEffect(()=>{
        if(vehicle?.catalogItem?.length){
            setCatalogItems(vehicle?.catalogItem)
        }
    },[JSON.stringify(vehicle?.catalogItem)])

    const vehicleTypeDropdownList:any = useMemo(() => {
        return vehicleType?.map((vehicle: any) => {
            return {
                ...vehicle,
                label: vehicle?.text,
                value: vehicle?.value,
            }
        })
    }, [vehicleType])


    useEffect(() => {
        if (vehicle?.requestIndex === makeList?.requestIndex) {
            const tempMakeList = makeList?.response?.filter((make: any) => !make?.disabled)?.map((make: any) => {
                return {
                    ...make,
                    label: make?.text,
                    value: make?.value,
                }
            })
            setMakeDropDown(tempMakeList)
        }
    }, [makeList])

    useEffect(()=>{
        if(vehicle?.requestIndex === managedEquipmentDropDown?.requestIndex && managedEquipmentDropDown?.response?.length){
            const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
                if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                    return {
                        ...vehicleRequest,
                        searchDropdowns: managedEquipmentDropDown?.response
                    }
                }
                return vehicleRequest
            })
            dispatch(setOrderData(tempOrderData))
        }
    },[managedEquipmentDropDown])
    useEffect(() => {
        if (vehicle?.requestIndex === vehicleSpecList?.requestIndex) {
            const tempSpecList = vehicleSpecList?.response?.map((spec: any) => {
                return {
                    ...spec,
                    label: spec?.description,
                    value: spec?.description,
                }
            })
            setSpecDropDown(tempSpecList)
        }
    }, [vehicleSpecList])

    useEffect(() => {
        if (vehicle?.requestIndex === attachmentList?.requestIndex) {
            const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
                if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                    vehicleRequest?.selectedCatalogItems?.map((element:any)=>{
                        if(!element?.price){
                            if(!attachmentList?.list?.length) {
                                props?.setShowCartClicked(false)
                                vehicleRequest.attachmentError = "Please upload attachments."
                            }else{
                                vehicleRequest.attachmentError = ""
                            }
                        }
                    })
                    return {
                        ...vehicleRequest,
                        attachments: attachmentList?.list
                    }
                }
                return vehicleRequest
            })
            dispatch(setOrderData(tempOrderData))
            setAttachmentsList(attachmentList?.list ?? []);
            setList(attachmentList?.list ?? [])
        }
      }, [attachmentList?.list])
    
    const equipmentTypeDropdownList:any = useMemo(()=>{
        return managedEquipementsList?.map((equipement: any) => {
            return {
                ...equipement,
                label: equipement?.text,
                text:  equipement?.text,
                value: equipement?.value
            }
        })
    }, [managedEquipementsList])

    const onChangeQuantityVehicle = (e: any) => {
            const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any)=>{
                if(vehicleRequest?.requestIndex === vehicle?.requestIndex){
                    if (isNaN(e.target.value.toString()) || isNaN(parseInt(e?.target?.value)) || parseInt(e.target.value) <= 0) {
                        return {
                            ...vehicleRequest,
                            quantityVehicleError: "Please enter a valid quantity",
                            quantityVehicle: ''
                        }
                    }else{
                        return {
                            ...vehicleRequest,
                            quantityVehicleError: '',
                            quantityVehicle: parseInt(e?.target?.value)
                        }
                    }
                    
                }
                return vehicleRequest
            })
            dispatch(setOrderData(tempOrderData))
    }

    const onChangeCommentehicle = (e: any) => {
            const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any)=>{
                if(vehicleRequest?.requestIndex === vehicle?.requestIndex){
                    if(e.target.value.length > 500){
                        return {
                            ...vehicleRequest,
                            comment: e.target.value,
                            commentError: "Please enter Comment less than 500 characters"
                        }
                    }else{
                        return {
                            ...vehicleRequest,
                            comment: e.target.value,
                            commentError: ""
                        }
                    }
                }
                return vehicleRequest
            })
            dispatch(setOrderData(tempOrderData))
    }
    const onChangeQuantitymanagedEquipment = (e: any, item:any) => {
        e.stopPropagation();
        const isValid = isNaN(e.target.value.toString()) ||  isNaN(parseInt(e?.target?.value)) || parseInt(e.target.value) <= 0 
        let list = catalogItems.map((element:any) => {
            if (element.assetModelId === item.assetModelId) {
                if (!isValid) {
                    element.quantity = parseInt(e.target.value);
                    element.quantityError = '';
                }else {
                    element.quantity = '';
                    element.quantityError = "Please enter a valid quantity";
                }    
            }        
            return element;                
        })  
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
            if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                const catalogItem = vehicleRequest?.selectedCatalogItems?.map((catalogVehicle: any) => {
                    if (catalogVehicle?.assetModelId === item?.assetModelId) {
                        if (!isValid) {
                            catalogVehicle.quantity = parseInt(e.target.value);
                            catalogVehicle.quantityError = '';
                        }else {
                            catalogVehicle.quantity = '';
                            catalogVehicle.quantityError = "Please enter a valid quantity";
                        }
                        return catalogVehicle
                    }
                    return catalogVehicle
                })
                return {
                    ...vehicleRequest,
                    selectedCatalogItems: catalogItem
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
        setCatalogItems(list); 
    }

    const incrementQuantityManagedEquipment = (e: any, item: any) => {
        e.stopPropagation();
        let catalogItemsTemp = catalogItems?.length ? JSON.parse(JSON.stringify(catalogItems)) : []
        let list = catalogItemsTemp.map((element: any) => {
            if (element.assetModelId === item.assetModelId) {
                element.quantity = parseInt(element?.quantity.toString()) ? parseInt(element?.quantity.toString()) + 1 : 1;
                element.quantityError = ''
            }
            return element;
        })
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
            if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                const catalogItem = vehicleRequest?.selectedCatalogItems?.map((catalogVehicle: any) => {
                    if (catalogVehicle?.assetModelId === item?.assetModelId) {
                        catalogVehicle.quantity =  parseInt(catalogVehicle.quantity.toString()) ? parseInt(catalogVehicle.quantity.toString()) + 1 : 1 
                        catalogVehicle.quantityError = ''
                        return catalogVehicle
                    }
                    return catalogVehicle
                })
                return {
                    ...vehicleRequest,
                    selectedCatalogItems: catalogItem
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
        setCatalogItems(list);
    }
    
    const decrementQuantityManagedEquipment = (e:any, item:any) => {
        e.stopPropagation();
        let catalogItemsTemp = catalogItems?.length ? JSON.parse(JSON.stringify(catalogItems)) : []
        let list = catalogItemsTemp.map((element:any) => {
            if (element.assetModelId === item.assetModelId) {
                element.quantity = parseInt(element?.quantity.toString()) - 1                             
            }  
            return element;      
        })
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
            if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                const catalogItem = vehicleRequest?.selectedCatalogItems?.map((catalogVehicle: any) => {
                    if (catalogVehicle?.assetModelId === item?.assetModelId) {
                        catalogVehicle.quantity = parseInt(catalogVehicle.quantity.toString()) - 1
                        return catalogVehicle
                    }
                    return catalogVehicle
                })
                return {
                    ...vehicleRequest,
                    selectedCatalogItems: catalogItem
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
        setCatalogItems(list);
    }

    const validateVehiclePanel = (vehicle: any) => {
        let isValid = true;
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))
        tempOrderData?.forEach((vehicleRequest: any) => {
            if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                if (!vehicleRequest?.selectedVehicleType?.value) {
                    isValid = false;
                    vehicleRequest.selectedVehicleTypeError = 'Please select vehicle type'
                }
                if (!vehicleRequest?.selectedMake?.value) {
                    isValid = false;
                    vehicleRequest.selectedMakeError = 'Please select make'
                }
                if (!vehicleRequest?.selectedSpec?.value) {
                    isValid = false;
                    vehicleRequest.selectedSpecError = 'Please select vehicle spec'
                }
                if (vehicleRequest?.quantityVehicle === 0) {
                    isValid = false;
                    vehicleRequest.quantityVehicleError = 'Please select atleast 1 quantity'
                }

                if (vehicleRequest?.selectedVehicleTypeError ||
                    vehicleRequest?.selectedMakeError ||
                    vehicleRequest?.quantityVehicleError ||
                    vehicleRequest?.selectedSpecError || vehicleRequest?.commentError
                ) {
                    isValid = false;
                } 
            }
        })
        dispatch(setOrderData(tempOrderData))
        return isValid
    }

    let validateManagedEqipment = () => {
        let isValid = true
        let isLengthZero = false;
        let orderDetailsTemp = orderDetails?.length ? JSON.parse(JSON.stringify(orderDetails)) : []
        orderDetailsTemp?.map((orderItem: any) => {
            if (orderItem?.requestIndex == vehicle?.requestIndex) {
                if (orderItem?.selectedCatalogItems?.length <= 0) {
                    isValid = false;
                    isLengthZero = true;
                }
                if (!orderItem?.selectedEquipementType?.hasOwnProperty("label")) {
                    orderItem.selectedEquipementTypeError = "Please select equipment type"
                    isValid = false
                }
                const filteredItems = orderItem?.selectedCatalogItems?.filter((item:any) => item?.quantityError?.length > 0)
                if(filteredItems?.length > 0){
                    isValid = false
                }
            }
        })
        dispatch(setOrderData(orderDetailsTemp))
        return {isValid, isLengthZero}
    }

    let validateNoNAP = () => {
        let isValid = true
        let orderDetailsTemp = orderDetails?.length ? JSON.parse(JSON.stringify(orderDetails)) : []
        orderDetailsTemp?.map((orderItem: any) => {
            if (orderItem?.requestIndex == vehicle?.requestIndex) {
                orderItem?.selectedCatalogItems?.map((element:any)=>{
                    if(!element?.price){
                        if(!orderItem?.attachments?.length) {
                            isValid = false;
                            props?.setShowCartClicked(false)
                            orderItem.attachmentError = "Please upload attachments."
                        };
                        if(!(DealerDetailsValidation.validateDealer(element?.managedEquipmentDealer)?.isValid)){
                            isValid = false;
                        }
                    }
                })
            }
        })
        dispatch(setOrderData(orderDetailsTemp))
        return isValid
    }

    const hideDialog = () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
    };

    const handleAddClick = () => {
        let tempCartData = orderCartDetails ? JSON?.parse(JSON.stringify(orderCartDetails)) : []
        let tempVehicleValues: any = {};
        if (vehicle?.requestType === CONSTANTS?.VEHICLE_REQUEST) {
            let isValid = validateVehiclePanel(vehicle)
            let cartRequestIndexArr = tempCartData?.map((item: any) => (item?.requestIndex))
            if (isValid) {
                props?.setShowCartClicked(true)
                const label = isItemAddedToCart ?  "Updated Successfully" : "Successfully added to the cart";
                dispatch(showMyCartAlert(true, label))
                tempVehicleValues = {
                    orderRequestSubTypeId: parseInt(vehicle?.selectedVehicleType?.value),
                    orderRequestSubTypeLabel: vehicle?.selectedVehicleType?.label,
                    vehicleTypeId: vehicle?.selectedVehicleType?.value,
                    orderTypeId: vehicle?.orderTypeId,
                    orderType: vehicle?.requestType,
                    requestIndex: vehicle?.requestIndex,
                    orderSearchCriteriaId: vehicle?.orderSearchCriteriaId || 0,
                    requests: [
                        {
                            ...vehicle?.selectedSpec,
                            requestId: vehicle?.requestId ? parseInt(vehicle?.requestId) : 0,
                            orderTypeId: vehicle?.orderTypeId,
                            itemNumber: vehicle?.itemNumber ?? 0,
                            quantity: vehicle?.quantityVehicle,
                            price: vehicle?.selectedSpec?.price,
                            comments: vehicle?.comment,
                            make: vehicle?.selectedMake?.text,
                            description: vehicle?.selectedSpec?.description,
                            attachments: vehicle?.attachments,
                            equipmentIndex: vehicle?.requestIndex,
                            assetModelId: vehicle?.selectedSpec?.assetModelId,
                            collapse: true,
                        }
                    ]
                }
                if (cartRequestIndexArr?.includes(vehicle?.requestIndex)) {
                    tempCartData = tempCartData?.map((item: any) => {
                        if (item?.requestIndex == vehicle?.requestIndex) {
                            return tempVehicleValues;
                        } else {
                            return item;
                        }
                    })
                } else {
                    tempCartData.push(tempVehicleValues)
                }
                dispatch(setOrderCartData(tempCartData))
            }
        } else {
            let cartEquipments = orderCartDetails?.length ? JSON.parse(JSON.stringify(orderCartDetails)) : []
            let isValid = validateManagedEqipment();
            if (isValid.isValid) {
                const label = isItemAddedToCart ?  "Updated Successfully" : "Successfully added to the cart";
                dispatch(showMyCartAlert(true, label))
                props?.setShowCartClicked(true)
                let isNoNAPValid = validateNoNAP();
                if(isNoNAPValid){
                    let cartRequestIndexArr = cartEquipments?.map((item: any) => (item?.requestIndex))
                    if (cartRequestIndexArr?.includes(vehicle?.requestIndex)) {
                        tempCartData = tempCartData?.map((item: any) => {
                            if (item?.requestIndex == vehicle?.requestIndex) {

                                return handleManagedEquipmentAddClick(vehicle);
                            } else {
                                return item;
                            }
                        })
                    } else {
                        tempVehicleValues = handleManagedEquipmentAddClick(vehicle);
                        tempCartData.push(tempVehicleValues)
                    }
                    dispatch(setOrderCartData(tempCartData))
                }
            } else if(isValid?.isLengthZero){
                let decriptionTxt = (<>
                    <p>Please select atleast one catalog item.</p>
                </>);
                setPopupcontent({
                    ...Popupcontent,
                    titleImg: ConfirmationBee,
                    title: CONSTANTS.TITLE_CONFIRMATION,
                    isDialogVisible: true,
                    isTitleWarning: false,
                    subtextcontent: decriptionTxt,
                    outlineBtnText: "Close",
                    popupOutlinebtnOnclick: () => {
                        hideDialog();
                    },
                    isSingleConfirmationBtn: true,
                });
            }
        }

    }

    const handleManagedEquipmentAddClick = (vehicle:any) => {
        let requestTemp:any = [];
        vehicle?.selectedCatalogItems?.map((element:any, index: any)=>{
            requestTemp.push({
                ...element,
                requestId: element?.requestId ? parseInt(element?.requestId) : 0,
                orderTypeId: vehicle?.orderTypeId,
                itemNumber: element?.itemNumber,
                quantity: element?.quantity,
                price: element?.managedEquipmentDealer?.hasOwnProperty("managedEquipmentDealerQuotePriceId") ? element?.calculatedPrice : element?.price,
                comments: "",
                make: element?.make,
                description: element?.description,
                attachments: vehicle?.attachments,
                requestIndex: vehicle?.requestIndex,
                equipmentIndex: element?.equipmentIndex,
                managedEquipmentDealer: element?.managedEquipmentDealer,
                assetModelId: element?.equipmentIndex,
                collapse: true,
            })
        })

        return {
            orderTypeId: vehicle?.orderTypeId,
            orderRequestSubTypeId : vehicle?.selectedEquipementType?.value,
            orderRequestSubTypeLabel: vehicle?.selectedEquipementType?.text,
            vehicleTypeId: vehicle?.selectedEquipementType?.value,
            manufacturerId: vehicle?.searchCriteria?.manufacturerId || 0,
            stateAvailabilityId: vehicle?.searchCriteria?.stateAvailabilityId || 0,
            programStatusId: vehicle?.searchCriteria?.programStatusId || 0,
            annualHoursId: vehicle?.searchCriteria?.annualHoursId || 0,
            deckSizeId: vehicle?.searchCriteria?.deckSizeId || 0,
            deckTypeId: vehicle?.searchCriteria?.deckTypeId || 0,
            autonomousId: vehicle?.searchCriteria?.autonomousId || 0,
            sizeId: vehicle?.searchCriteria?.sizeId || 0,
            typeId: vehicle?.searchCriteria?.typeId || 0,
            parentVehicleId: vehicle?.searchCriteria?.parentVehicleId || 0,
            styleId: vehicle?.searchCriteria?.styleId || 0,
            lengthId: vehicle?.searchCriteria?.lengthId || 0,
            fuelTankId: vehicle?.searchCriteria?.fuelTankId || 0,
            chargingStationId: vehicle?.searchCriteria?.chargingStationId || 0,
            treeCareEquipmentTypeId: vehicle?.searchCriteria?.treeCareEquipmentTypeId || 0,
            horsePowerId: vehicle?.searchCriteria?.horsePowerId || 0,
            fuelTypeId: vehicle?.searchCriteria?.fuelTypeId || 0,
            seatingCapacityId: vehicle?.searchCriteria?.seatingCapacityId || 0,
            enclosedCabId: vehicle?.searchCriteria?.enclosedCabId || 0,
            capacityId: vehicle?.searchCriteria?.capacityId || 0,
            categoryId: vehicle?.searchCriteria?.categoryId || 0,
            requestIndex: vehicle?.requestIndex,
            orderSearchCriteriaId: vehicle?.orderSearchCriteriaId || 0,
            requests: requestTemp
        }
    }
  
    const handleOnClickAttchHead = (e:any) => {
        e.stopPropagation();
    }
    const handleCardClick =(item:any)=>{
        let isValid = true;
        orderDetails?.forEach((val: any)=> {
            const list = val?.selectedCatalogItems?.filter((selectedItem: any) => !item?.isSelected && selectedItem?.assetModelId === item?.assetModelId)
            if(list?.length > 0){
                isValid = false;
            }
        })
        if(isValid){
        let catalogItemTemps = [...catalogItems]
        const tempOrderData = orderDetails ? JSON.parse(JSON.stringify(orderDetails)) : []
        catalogItemTemps?.forEach((element: any, _i: any) => {
            if (element.assetModelId === item.assetModelId) {
                element.isSelected = !element.isSelected;
                setCatalogItems(catalogItemTemps);
                if(!element.isSelected){
                    tempOrderData?.forEach((val: any)=> {
                        if(val?.requestIndex == vehicle?.requestIndex){
                            val.selectedCatalogItems = val?.selectedCatalogItems?.filter((selectedItem: any) => selectedItem?.assetModelId !== item?.assetModelId)
                            let NoNAPList:any = [];
                            NoNAPList = val?.selectedCatalogItems?.filter((selectedItem: any) => !selectedItem?.price)
                            if(!NoNAPList?.length){
                                val.attachmentError = "";
                            }
                        }
                    })
                    dispatch(setOrderData(tempOrderData))
                }else{
                     tempOrderData?.forEach((val: any)=> {
                        if(val?.requestIndex == vehicle?.requestIndex){
                            element.isSelected = true
                            element.equipmentIndex = element.assetModelId
                            element.managedEquipmentDealer = element?.price ? {} :  {
                                managedEquipmentDealerQuotePriceId: 0,
                                reasonId: 0,
                                dealerName: "",
                                quotePrice: 0,
                                estimatedPrice: 0,
                                dealerPhone: "",
                                dealerContact: "",
                                dealerEmail: "",
                                dealerAdd1: "",
                                dealerAdd2: "",
                                dealerAdd3: "",
                                dealerCity: "",
                                dealerState: "",
                                dealerZip: ""
                              }
                            val?.selectedCatalogItems?.push(element)
                        }
                    })
                    dispatch(setOrderData(tempOrderData)) 
                }
            }
        })        
    }else{
        let decriptionTxt = (<>
            <p>This item is already selected. Please increase quantity there.</p>
        </>);
        setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: CONSTANTS.TITLE_CONFIRMATION,
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "Ok",
            popupOutlinebtnOnclick: () => {
                hideDialog();
            },
            isSingleConfirmationBtn: true,
        });
    }
    }
    const incrementQuantityVehicle = () => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any)=>{
            
            if(vehicleRequest?.requestIndex === vehicle?.requestIndex){
                return {
                    ...vehicleRequest,
                    quantityVehicle: parseInt(vehicleRequest?.quantityVehicle.toString()) ? parseInt(vehicleRequest?.quantityVehicle.toString()) + 1 : 1
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
    }
    const decrementQuantityVehicle = () => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any)=>{
            if(vehicleRequest?.requestIndex === vehicle?.requestIndex){
                return {
                    ...vehicleRequest,
                    quantityVehicle: parseInt(vehicleRequest?.quantityVehicle.toString()) - 1
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
    }

    const handleResetClickVehicle = () => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any)=>{
            if(vehicleRequest?.requestIndex === vehicle?.requestIndex){
                return {
                    ...vehicleRequest,
                    selectedVehicleType: {},
                    selectedMake: '',
                    quantityVehicle: 1,
                    selectedSpec: {},
                    comment: '',
                    selectedVehicleTypeError: '',
                    selectedMakeError: '',
                    quantityVehicleError: '',
                    selectedSpecError: '',
                    commentError: ''
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
    }

    const resetOnClick = () => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
            if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                setCatalogItems([])
                return {
                    ...vehicleRequest,
                    selectedEquipementType: {},
                    selectedEquipementTypeError: '',
                    searchCriteria: {},
                    selectedCatalogItems: []
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
        setShowManagedEquipDetails(false)
    }

    const deleteItemFromCart = (requestIndex: any) => {
        let cartDetailsTemp = JSON.parse(JSON.stringify(orderCartDetails))
        cartDetailsTemp?.map((searchItem: any, searchIndex: any) => {
            if (searchItem?.requestIndex == requestIndex) {
                cartDetailsTemp?.splice(searchIndex, 1)
            }
        })
        dispatch(setOrderCartData(cartDetailsTemp))
    }

    const handleClickDeletevehicle = () => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.filter((vehicleRequest: any) => vehicleRequest?.requestIndex !== vehicle?.requestIndex)
        dispatch(setOrderData(tempOrderData))
        dispatch(removeBulkOrderAttachment([], vehicle?.requestIndex))
        deleteItemFromCart(vehicle?.requestIndex)
    }

    const handleClickDeleteEquipment = () => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.filter((equipmentRequest: any) => equipmentRequest?.requestIndex !== vehicle?.requestIndex)
        dispatch(setOrderData(tempOrderData))
        setCatalogItems([])
        dispatch(removeBulkOrderAttachment([], vehicle?.requestIndex))
        deleteItemFromCart(vehicle?.requestIndex)
    }

    const equipmentTypeOnChange = (e:any, item:any) => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any)=>{
            if(vehicleRequest?.requestIndex === vehicle?.requestIndex){
                setCatalogItems([])
                return {
                    ...vehicleRequest,
                    selectedEquipementType: item,
                    selectedEquipementTypeError: '',
                    searchCriteria: {},
                    selectedCatalogItems: [],
                    orderSearchCriteriaId: 0
                }
            }
            return vehicleRequest
        })
        if(vehicle?.requestType === CONSTANTS?.MANAGED_EQUIPMENT && item?.value){
            dispatch(getBulkOrderManagedEquipmentDropDown(item?.value,vehicle.requestIndex))
            setShowManagedEquipDetails(true)
            setCatalogItems([])
        }
        dispatch(setOrderData(tempOrderData))
    }
    const vehicleTypeOnChange = (e:any, item:any) => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any)=>{
            if(vehicleRequest?.requestIndex === vehicle?.requestIndex){
                return {
                    ...vehicleRequest,
                    selectedVehicleType: item,
                    selectedVehicleTypeError: '',
                    selectedMake: {},
                    selectedSpec: {},
                    comment: '',
                    quantityVehicle: 1
                }
            }
            return vehicleRequest
        })
        if(vehicle?.requestType === CONSTANTS?.VEHICLE_REQUEST && item?.value){
            setShowVehicleDetails(true)
        }
        dispatch(setOrderData(tempOrderData))
    }

    const makeOnChange = (e:any, item:any) => {
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any)=>{
            if(vehicleRequest?.requestIndex === vehicle?.requestIndex){
                return {
                    ...vehicleRequest,
                    selectedMake: item,
                    selectedMakeError: '',
                    selectedSpec: '',
                    selectedSpecError: ''
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
    }

    const vehicleSpecOnChange = (e: any, item: any) => {
        const isInValidDesc = orderDetails?.find((spec: any) => spec?.selectedSpec?.description === item?.description && spec?.requestIndex !== vehicle?.requestIndex && spec?.selectedVehicleType?.value == vehicle?.selectedVehicleType?.value && spec?.selectedMake?.value == vehicle?.selectedMake?.value)
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
            if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                if (isInValidDesc) {
                    return {
                        ...vehicleRequest,
                        selectedSpec: item,
                        selectedSpecError: 'Selected vehicle Make and Specification already exists, kindly increase quantity of existing Vehicle'
                    }
                } else {
                    return {
                        ...vehicleRequest,
                        selectedSpec: item,
                        selectedSpecError: ''
                    }
                }
            }
            return vehicleRequest
        })
        dispatch(setOrderData(tempOrderData))
    }

    const handleResetClickEquipment = () => {
        setShowManagedEquipDetails(false)
    }
    
    const searchOnClick = () => {
        let isValid = true
        let orderDetailsTemp = orderDetails?.length ? JSON.parse(JSON.stringify(orderDetails)) : []
        orderDetailsTemp?.map((orderItem: any) => {
            if (orderItem?.requestIndex == vehicle?.requestIndex) {
                if (!orderItem?.selectedEquipementType?.hasOwnProperty("label")) {
                    orderItem.selectedEquipementTypeError = "Please select equipment type"
                    isValid = false
                    dispatch(setOrderData(orderDetailsTemp))
                }
            }
        })
        
        if(isValid){
        const tempOrderData = JSON.parse(JSON.stringify(orderDetails))?.map((vehicleRequest: any) => {
            if (vehicleRequest?.requestIndex === vehicle?.requestIndex) {
                setCatalogItems([])
                return {
                    ...vehicleRequest,
                    selectedCatalogItems: []
                }
            }
            return vehicleRequest
        })
        setSearchCatalogItem(true)
        dispatch(setOrderData(tempOrderData))
        const bodyToPost = {
            filterDropdownIds: Object.values({
                ...vehicle?.searchCriteria,
                subTypeId: undefined,
            }).filter((managedEquipmentValues: any) => managedEquipmentValues != null)
                .map((x?: any) => Number(x)),
            subTypeId: parseInt(vehicle?.selectedEquipementType?.value)
        };
        dispatch(getCatalogItems(bodyToPost, vehicle?.requestIndex));
    }
    }

    const isUploaded = (name: string) =>
        attachmentsList.find((x: any) => getFileName(x.attachmentUrl) === name);

    // To upload attachments
    const onUploadClick = (fileList: Array<File>) => {
        setError("");
        const filteredList = [
            ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
        ];
        if (filteredList.length > 0 && filteredList.length <= 5) {
            setError("");
            let totalSize = 0;
            filteredList.forEach((file: File) => {
                totalSize = totalSize + (file.size || 0);
            });
            if (totalSize <= 5000000) {
                setError("");
                const formData = new FormData();
                formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

                for (let i = 0; i < filteredList.length; i++) {
                    formData.append("Files", filteredList[i] as any);
                }
                dispatch(uploadBulkOrderAttachments({ formData, filteredList, list: attachmentsList }, vehicle?.requestIndex))
            } else {
                setError("Please Upload files without exceeding maximum size of 5MB");
            }
        } else if (fileList.length > 5) {
            setError(
                "Please Upload files without exceeding maximum limit of 5 files"
            );
        } else {
            if (fileList.length > 0 && !filteredList.length) {
                setError("All files are uploaded try to add new files");
            } else {
                setError("Choose at least 1 file to upload");
            }
        }
    };  

    const onRemoveClick = (index: number) => {
        const newArr = attachmentsList.slice();
        newArr.splice(index, 1);
        dispatch(removeBulkOrderAttachment(newArr, vehicle?.requestIndex))
        setError("");
    };

    const isItemAddedToCart = useMemo(()=>{
        let itemsInCart = (orderCartDetails ?? [])?.map((vehicle: any)=> vehicle?.requestIndex)
        if(itemsInCart?.includes(vehicle?.requestIndex)){
            return true
        } else {
            return false
        }
    }, [orderCartDetails, orderDetails])

    const isAttachmentsRequired = useMemo(()=>{
        let NoNAPList:any = [];
        NoNAPList = vehicle?.selectedCatalogItems?.filter((selectedItem: any) => selectedItem?.managedEquipmentDealer?.hasOwnProperty('managedEquipmentDealerQuotePriceId'))
        return NoNAPList?.length ? true : false;
    }, [vehicle])

    return(
        <OrderTypeSelection 
            list={list} 
            setList={setList} 
            error={error} 
            setError={setError} 
            SelectOrderType={props?.SelectOrderType}
            vehicleTypeDropdownList={vehicleTypeDropdownList}
            makeDropdownList={makeDropDown}
            vehicleSpecDropdownList={specDropDown}
            equipmentTypeDropdownList={equipmentTypeDropdownList}
            incrementQuantityManagedEquipment={incrementQuantityManagedEquipment}
            decrementQuantityManagedEquipment={decrementQuantityManagedEquipment}
            onChangeQuantitymanagedEquipment={onChangeQuantitymanagedEquipment}
            handleAddClick={handleAddClick}
            handleOnClickAttchHead={handleOnClickAttchHead}
            catalogItemDetails={catalogItems}
            handleCardClick={handleCardClick}
            incrementQuantityVehicle={incrementQuantityVehicle}
            decrementQuantityVehicle={decrementQuantityVehicle}
            onChangeQuantityVehicle={onChangeQuantityVehicle}
            listVehicle={listVehicle}
            errorVehicle={errorVehicle}
            setListVehicle={setListVehicle}
            setErrorVehicle={setErrorVehicle}
            showVehicleDetails={showVehicleDetails}
            handleResetClickVehicle={handleResetClickVehicle}
            handleClickDeletevehicle={handleClickDeletevehicle}
            handleClickDeleteEquipment={handleClickDeleteEquipment}
            vehicleRequest={props?.vehicleRequest}
            equipmentRequest={props?.equipmentRequest}
            equipmentTypeOnChange={equipmentTypeOnChange}
            showManagedEquipDetails={showManagedEquipDetails}
            handleResetClickEquipment={handleResetClickEquipment}
            vehicleTypeOnChange={vehicleTypeOnChange}
            makeOnChange={makeOnChange}
            vehicleSpecOnChange={vehicleSpecOnChange}
            orderDetails={orderDetails}
            vehicle={vehicle}
            resetOnClick={resetOnClick}
            searchOnClick={searchOnClick}
            onChangeCommentehicle={onChangeCommentehicle}
            onUploadClick={onUploadClick}
            uploadedList={attachmentsList}   
            onRemoveClick={onRemoveClick}
            isItemAddedToCart={isItemAddedToCart}
            Popupcontent = {Popupcontent}
            isAttachmentsRequired={isAttachmentsRequired}
            isEditOrder={isEditOrder}
            hideDialog={hideDialog}
        />
    )
}

export default OrderTypeSelectionContainer  